module.exports = __webpack_public_path__ + "img/angle-right-solid-g.bdad4b41.svg";